var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import AsyncState from "./AsyncState";
import AsyncStateGroup from "./AsyncStateGroup";
export var updateAsyncState = function (setAsyncState, promiseOrAsyncFn, options) { return __awaiter(void 0, void 0, void 0, function () {
    var pendingAt, timeoutId, resolved, possiblyResolve, valuePromise, promise, minimumPendingPromise, value_1, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                pendingAt = null;
                setAsyncState(function (currentState) {
                    var newState = (options === null || options === void 0 ? void 0 : options.refresh) ? AsyncState.refresh(currentState) : AsyncState.submit(currentState);
                    pendingAt = newState.pendingAt;
                    return newState;
                });
                timeoutId = undefined;
                resolved = false;
                possiblyResolve = function () {
                    throw new Error("[react-async-stateful] This should never happen!");
                    return false;
                };
                valuePromise = new Promise(function (resolve) {
                    possiblyResolve = function (stateUpdater) {
                        if (resolved) {
                            return false;
                        }
                        if (timeoutId) {
                            clearTimeout(timeoutId);
                        }
                        resolved = true;
                        setAsyncState(function (currentState) {
                            if (currentState.pendingAt !== pendingAt) {
                                // this state has been updated again since we started -- we are no longer in charge of resolving this state and shouldn't update it
                                return currentState;
                            }
                            var updatedState = stateUpdater(currentState);
                            resolve(updatedState);
                            return updatedState;
                        });
                        return true;
                    };
                });
                if (options === null || options === void 0 ? void 0 : options.timeout) {
                    timeoutId = setTimeout(function () {
                        var error = new Error("[react-async-stateful] Async update timed out, took longer than " + options.timeout + "ms");
                        if (possiblyResolve(function (state) { return AsyncState.reject(state, error); })) {
                            console.error(error);
                        }
                    }, options.timeout);
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                promise = typeof promiseOrAsyncFn === "function"
                    ? promiseOrAsyncFn()
                    : promiseOrAsyncFn;
                if (typeof promise.then !== "function") {
                    throw new Error("[react-async-stateful] " + (typeof promiseOrAsyncFn === "function"
                        ? "Function provided did not return a promise"
                        : "First argument was not a promise or an async function"));
                }
                minimumPendingPromise = undefined;
                if (options === null || options === void 0 ? void 0 : options.minimumPending) {
                    minimumPendingPromise = new Promise(function (resolve) { return setTimeout(resolve, options.minimumPending); });
                }
                return [4 /*yield*/, Promise.all([promise, minimumPendingPromise])];
            case 2:
                value_1 = (_a.sent())[0];
                if (value_1 === undefined) {
                    // shouldn't resolve to undefined, as that denotes we haven't resolved at all
                    value_1 = null;
                }
                possiblyResolve(function (state) { return AsyncState.resolve(state, value_1); });
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                if (possiblyResolve(function (state) { return AsyncState.reject(state, error_1); })) {
                    console.error("[react-async-stateful] Updating async state failed", error_1);
                }
                return [3 /*break*/, 4];
            case 4: return [4 /*yield*/, valuePromise];
            case 5: 
            // wait for react to have updated our state
            return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var updateAsyncStateElement = function (stateGroup, setAsyncState, key, promiseOrAsyncFn, options) { return __awaiter(void 0, void 0, void 0, function () {
    var valueResolve, valuePromise, promise, update;
    return __generator(this, function (_a) {
        valueResolve = function () {
            throw new Error("This should never happen!");
        };
        valuePromise = new Promise(function (resolve) {
            valueResolve = resolve;
        });
        promise = typeof promiseOrAsyncFn === "function"
            ? promiseOrAsyncFn()
            : promiseOrAsyncFn;
        update = function () { return __awaiter(void 0, void 0, void 0, function () {
            var updateElement;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        updateElement = function (elementOrUpdater) { return setAsyncState((function (prevState) {
                            var element = typeof elementOrUpdater === "function" ? elementOrUpdater(AsyncStateGroup.getOrCreateElement(prevState, key)) : elementOrUpdater;
                            var updatedState = AsyncStateGroup.setElement(prevState, key, element);
                            if (updatedState.resolved || updatedState.rejected) {
                                valueResolve(updatedState);
                            }
                            return updatedState;
                        })); };
                        return [4 /*yield*/, updateAsyncState(updateElement, promise, options)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        update();
        return [2 /*return*/, valuePromise];
    });
}); };
